import { BitwiseHelper, Message } from '@ncss/message';
import { NwkRoute } from '@ncss/models';
import { ByteList } from 'byte-list';

export enum NL4BLERouteMessageType {
    GROUP_MASK = 0x1790,
}

export class NL4BLERouteMessage extends Message {
    private flags = 0;
    routes: NwkRoute[] = [];

    get count() { return BitwiseHelper.GetBits(this.flags, 0, 4); }
    get isSorting() { return !!BitwiseHelper.GetBits(this.flags, 4, 1); }

    constructor(type?: number) {
        super();
        this.type = type || NL4BLERouteMessageType.GROUP_MASK;
    }

    public serialize(): ByteList {
        const bytes = super.serialize();
        bytes.writeByte(this.count);
        for (let i = 0; i < this.count; ++i) {
            const route = new NwkRoute();
            route.serialize(bytes);
            this.routes.push(route);
        }
        return bytes;
    }

    public deserialize(bytes: ByteList): void {
        super.deserialize(bytes);
        this.flags = bytes.readByte();
        for (let i = 0; i < this.count; ++i) {
            const route = new NwkRoute();
            route.deserialize(bytes);
            this.routes.push(route);
        }
    }
}
